module.exports = __webpack_public_path__ + "img/skills.3286ea6.svg";